export interface IRgb {
	r: number;
	g: number;
	b: number;
}
export interface IHsv {
	h: number;
	s: number;
	v: number;
}
export function HSVtoRGB(hsv: IHsv): IRgb {
	const rgb = { r: 0, g: 0, b: 0 };
	const h = hsv.h / 60;
	const s = hsv.s;
	let v = hsv.v;

	const i = Math.floor(h) % 6;

	const f = h - Math.floor(h);
	const p = 255 * v * (1 - s);
	const q = 255 * v * (1 - (s * f));
	const t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (i) {
		case 0:
			rgb.r = v;
			rgb.g = t;
			rgb.b = p;
			break;
		case 1:
			rgb.r = q;
			rgb.g = v;
			rgb.b = p;
			break;
		case 2:
			rgb.r = p;
			rgb.g = v;
			rgb.b = t;
			break;
		case 3:
			rgb.r = p;
			rgb.g = q;
			rgb.b = v;
			break;
		case 4:
			rgb.r = t;
			rgb.g = p;
			rgb.b = v;
			break;
		case 5:
			rgb.r = v;
			rgb.g = p;
			rgb.b = q;
			break;
	}
	for (const key in rgb) {
		rgb[key] = Math.round(rgb[key]);
	}
	return rgb;
}
export function RGBToHex(rgb: IRgb): string {
	return Object.keys(rgb).reduce((hex, c) => {
		let h = rgb[c].toString(16).toUpperCase();
		h = h.length === 1 ? "0" + h : h;
		return hex += h;
	}, "#");
}

export function HexToRGB(hex: string): IRgb {
	const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	hex = hex.replace(shorthandRegex, (_m, r, g, b) =>
		r + r + g + g + b + b
	);

	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result ? {
		r: parseInt(result[1], 16),
		g: parseInt(result[2], 16),
		b: parseInt(result[3], 16)
	} : null;
}

export function RGBToHSV(rgb: IRgb): IHsv {
	let h;
	let s;

	const r = rgb.r / 255;
	const g = rgb.g / 255;
	const b = rgb.b / 255;
	const v = Math.max(r, g, b);
	const diff = v - Math.min(r, g, b);
	const diffc = c => {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		const rdif = diffc(r);
		const gdif = diffc(g);
		const bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}
	return {
		h: Math.floor(h * 360),
		s,
		v
	};
}
export function HexToHSV(hex: string): IHsv {
	return RGBToHSV(HexToRGB(hex));
}
export function isHex(hex: string): boolean {
	return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex);
}